// import axios from "axios";
// // import logger from "./logService";

// axios.interceptors.response.use(null, error => {
//   const expectedError =
//     error.response &&
//     error.response.status >= 400 &&
//     error.response.status < 500;

//   if (!expectedError) {
//     // logger.log(error);
//     toast.error("An unexpected error occurrred.");
//   }
//   return Promise.reject(error.response);
//   // return Promise.reject(error);
// });

// function setJwt(jwt) {
//   axios.defaults.headers.common["x-auth-token"] = jwt;
// }

// export default {
//   get: axios.get,
//   post: axios.post,
//   put: axios.put,
//   delete: axios.delete,
//   setJwt
// };
import axios from 'axios';
// import logger from "./logService";
import utilsService from '../utilsService';
import VIDABOO_CONSTANTS from '../../config/consts';

const privateState = {};

const initShowToast = (initShowToast) => {
  privateState.initShowToast = initShowToast;
};

axios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      error.status = 5000;
      error.response = {data: {}};
      if (axios.isCancel(error)) {
        // in case request was cancelled intentionally by user, file-upload for instance.
        error.response.data.isCanceled = true;
      } else {
        const toastObj = utilsService.getToastObj({
          toastTitle: 'Please check your internet connection',
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
        });
        initShowToast(toastObj);
      }
      // return Promise.reject(error); // handled in the application level
    }
    console.debug(error);
    return Promise.reject(error.response);
  },
);

function setJwt(jwt) {
  axios.defaults.headers.common['x-auth-token'] = jwt;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
}

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  cancelToken: axios.CancelToken,
  initShowToast,
};
export default httpService;
